/**
 * @generated SignedSource<<eafc790f7f12866d21922102e0a6158b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationNewsfeedProvider = "BOKAKLIPP" | "FALCON";
export type IntegrationNewsfeedCreateScreenMutation$variables = {
  info: string;
  provider: IntegrationNewsfeedProvider;
};
export type IntegrationNewsfeedCreateScreenMutation$data = {
  readonly store: {
    readonly createIntegrationNewsfeed: {
      readonly id: string;
    } | null;
  };
};
export type IntegrationNewsfeedCreateScreenMutation = {
  response: IntegrationNewsfeedCreateScreenMutation$data;
  variables: IntegrationNewsfeedCreateScreenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "info"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "provider"
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "info",
            "variableName": "info"
          },
          {
            "kind": "Variable",
            "name": "provider",
            "variableName": "provider"
          }
        ],
        "concreteType": "IntegrationNewsfeed",
        "kind": "LinkedField",
        "name": "createIntegrationNewsfeed",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationNewsfeedCreateScreenMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "IntegrationNewsfeedCreateScreenMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "4fd1060a65458397da1e40b03659adab",
    "id": null,
    "metadata": {},
    "name": "IntegrationNewsfeedCreateScreenMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationNewsfeedCreateScreenMutation(\n  $provider: IntegrationNewsfeedProvider!\n  $info: String!\n) {\n  store {\n    createIntegrationNewsfeed(provider: $provider, info: $info) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dd1b21a3f030a939224d7f1012a5b6e1";

export default node;
